(() => {
  if (window.HPFLetterSKUInstalled || !window.HPFLetterSKUConfig) return;
  window.HPFLetterSKUInstalled=true;
  const cfg=window.HPFLetterSKUConfig, originalFetch=window.fetch.bind(window);
  const isURL=(input,part)=>{try{return new URL(typeof input==='string'?input:input.url,location.href).pathname.includes(part)}catch{return false}};
  function payload(body){
    if(body instanceof FormData || body instanceof URLSearchParams)return Object.fromEntries(body.entries());
    if(typeof body==='string'){try{return JSON.parse(body)}catch{return Object.fromEntries(new URLSearchParams(body))}}
    return null;
  }
  function jsonOptions(options,data){return {...options,headers:{...Object.fromEntries(new Headers(options?.headers||{}).entries()),'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)}}
  function resolve(profile,material,count,glyph,role){
    const entry=profile.variants.find(v=>v.m===material&&v.n===count&&v.g===glyph&&v.r===role);
    if(!entry)throw new Error(cfg.required);
    return entry;
  }
  function components(profile,material,count,glyphs,quantity,baseProperties={},group){
    if(glyphs.length!==count||glyphs.some(x=>!profile.glyphs.includes(x)))throw new Error(cfg.required);
    const id=group||('letters-'+crypto.randomUUID());
    return glyphs.map((glyph,i)=>({id:resolve(profile,material,count,glyph,i?1:0).id,quantity,
      properties:{...baseProperties,[cfg.letter]:glyph,[cfg.bundle]:profile.labels[String(count)]+' · '+(i+1)+'/'+count,
        _letter_sku:'v1',_letter_bundle:id,_letter_piece:String(i+1),_letter_count:String(count)}}));
  }
  window.HPFLetterComponents=components;
  async function cart(){const r=await originalFetch('/cart.js?hpf_letter='+Date.now(),{cache:'no-store',headers:{Accept:'application/json'}});if(!r.ok)throw new Error(cfg.required);return r.json()}
  let repairPromise;
  async function repair(){
    const current=await cart();let changed=false;
    for(const item of current.items){
      if(item.properties?._letter_sku==='v1')continue;
      const p=cfg.products.find(p=>p.legacy[String(item.variant_id)]);
      if(!p)continue;
      const old=p.legacy[String(item.variant_id)], props=item.properties||{};
      const signature=String(item.variant_id)+'|'+JSON.stringify(Object.entries(props).sort(([a],[b])=>a.localeCompare(b)));
      let hash=2166136261;for(const char of signature){hash^=char.codePointAt(0);hash=Math.imul(hash,16777619)}
      const migration='legacy-'+item.variant_id+'-'+(hash>>>0).toString(16);
      let replacements;
      if(p.type==='bundle'){
        const glyphs=Array.from({length:old.n},(_,i)=>props[p.fields[i]]);
        if(glyphs.some(x=>!p.glyphs.includes(x)))continue;
        const group=migration;
        if((await cart()).items.some(x=>x.properties?._letter_bundle===group))replacements=[];
        else replacements=components(p,old.m,old.n,glyphs,item.quantity,{},group);
      }else{
        const glyph=props[p.letterField];if(!p.glyphs.includes(glyph))continue;
        const v=resolve(p,old.m,1,glyph,0);
        if(Number(v.id)===Number(item.variant_id))continue;
        const exists=(await cart()).items.some(x=>x.properties?._letter_legacy===migration);
        replacements=exists?[]:[{id:v.id,quantity:item.quantity,properties:{...props,_letter_sku:'v1',_letter_legacy:migration}}];
      }
      if(replacements.length){const add=await originalFetch('/cart/add.js',jsonOptions({method:'POST'},{items:replacements}));if(!add.ok)throw new Error(cfg.required)}
      // Automatic discount tiers can change a Shopify line key after adding
      // replacement pieces. Resolve the unchanged old line again before removal.
      const remaining=(await cart()).items.find(x=>x.variant_id===item.variant_id&&JSON.stringify(Object.entries(x.properties||{}).sort(([a],[b])=>a.localeCompare(b)))===JSON.stringify(Object.entries(props).sort(([a],[b])=>a.localeCompare(b))));
      if(remaining){const remove=await originalFetch('/cart/change.js',jsonOptions({method:'POST'},{id:remaining.key,quantity:0}));if(!remove.ok)throw new Error(cfg.required)}
      changed=true;
    }
    return changed;
  }
  function ensureRepair(){return repairPromise||(repairPromise=repair().catch(e=>{repairPromise=null;throw e}))}
  window.fetch=async function(input,options){
    if(options?.method?.toUpperCase()==='POST'&&isURL(input,'/cart/add')){
      const p=payload(options.body),active=window.HPFActiveLetterBundle;
      if(p&&active&&active.profile.variants.some(v=>String(v.id)===String(p.id))){
        await ensureRepair();
        const data=active.selection();
        const items=components(active.profile,data.material,data.count,data.glyphs,Number(p.quantity||1));
        const next={items};for(const key of ['sections','sections_url'])if(p[key])next[key]=p[key];
        const response=await originalFetch(input,jsonOptions(options,next));
        if(!response.ok)return response;
        const value=await response.json();
        if(value.items?.length&&!value.id)value.id=value.items[0].id;
        return new Response(JSON.stringify(value),{status:response.status,statusText:response.statusText,headers:response.headers});
      }
    }
    if(options?.method?.toUpperCase()==='POST'&&isURL(input,'/cart/change')){
      const p=payload(options.body);
      if(p){
        const current=await cart();const line=p.id?current.items.find(x=>x.key===p.id||String(x.id)===String(p.id)):current.items[Number(p.line)-1];
        const group=line?.properties?._letter_bundle;
        if(group){
          const updates=Object.fromEntries(current.items.filter(x=>x.properties?._letter_bundle===group).map(x=>[x.key,Number(p.quantity)]));
          const next={updates};for(const key of ['sections','sections_url'])if(p[key])next[key]=p[key];
          const url=new URL(typeof input==='string'?input:input.url,location.href);url.pathname=url.pathname.replace('/cart/change','/cart/update');
          return originalFetch(url.href,jsonOptions(options,next));
        }
      }
    }
    return originalFetch(input,options);
  };
  document.addEventListener('click',event=>{
    const anchor=event.target.closest('a[href*="/checkout"]');if(!anchor)return;
    event.preventDefault();event.stopImmediatePropagation();
    ensureRepair().then(()=>location.assign(anchor.href)).catch(()=>alert(cfg.required));
  },true);
  const start=()=>ensureRepair().then(changed=>{if(changed)location.reload()}).catch(e=>console.warn('Letter cart requires re-selection',e.message));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

